import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onEnterBind = this.onEnter.bind(this)
        this.onLeaveBind = this.onLeave.bind(this)
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.el
        this.$items = this.$('item')

        // Set data
        this.metrics = [];
        this.navIndex = this.getData('default-index')
            ? parseInt(this.getData('default-index'), 10)
            : -1;
        this.lastHoverIndex = -1

        // Set metrics
        this.setMetrics()

        // Bind events
        this.bindEvents()
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$items.forEach(($link) => {
            $link.addEventListener('mouseenter', this.onEnterBind)
            $link.addEventListener('mouseleave', this.onLeaveBind)
            $link.addEventListener('focusin', this.onEnterBind)
            $link.addEventListener('focusout', this.onLeaveBind)
        })

        window.addEventListener('resizeEnd', this.onResizeBind)
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind)
    }

    unbindEvents() {
        this.$items.forEach(($link) => {
            $link.removeEventListener('mouseenter', this.onEnterBind)
            $link.removeEventListener('mouseleave', this.onLeaveBind)
            $link.removeEventListener('focusin', this.onEnterBind)
            $link.removeEventListener('focusout', this.onLeaveBind)
        })

        window.removeEventListener('resizeEnd', this.onResizeBind)
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onEnter(e) {
        const $target = e.currentTarget
        const currentIndex = Array.from(this.$items).indexOf($target)

        this.computeTranslateX(currentIndex)
        this.computeWidth(currentIndex)
        this.computeIndex(currentIndex)
        this.showIndicator()
        this.lastHoverIndex = currentIndex
    }

    onLeave() {
        this.hideIndicator()
    }

    onResize() {
        this.setMetrics()
    }
    
    onFontsLoaded() {
        this.onResize()
    }

    ///////////////
    // Methods
    ///////////////
    setMetrics() {
        this.metrics = []

        this.$items.forEach(($link) => {
            this.metrics.push($link.offsetWidth)
        });
    }

    setActiveClass(activeIndex) {
        this.$items.forEach(($link, linkIndex) => {
            if (linkIndex === activeIndex) {
                $link.classList.add('is-active')
            } else {
                $link.classList.remove('is-active')
            }
        });
    }

    showIndicator(isShow) {
        this.$el.style.setProperty('--indicatorShow', '1')
    }

    hideIndicator() {
        this.$el.style.setProperty('--indicatorShow', '0')
    }

    computeTranslateX(index) {
        if (index < 0) {
            return
        }

        const metrics = [...this.metrics];
        metrics.length = index
        const translateX = metrics.reduce((a, b) => a + b, 0)
        this.$el.style.setProperty('--indicatorTranslateX', `${translateX}px`)
    }

    computeWidth(index) {
        if (index < 0) {
            return
        }

        const metrics = [...this.metrics]
        const width = metrics[index]
        this.$el.style.setProperty('--indicatorWidth', `${width}px`)
    }

    computeIndex(index) {
        if (index < 0) {
            this.$el.style.setProperty('--indicatorIndex', 0)
            return
        }

        this.$el.style.setProperty('--indicatorIndex', `${index}`)
    }
}
